import { render, staticRenderFns } from "./LocationPin.vue?vue&type=template&id=40a3b1c6&scoped=true&"
import script from "./LocationPin.vue?vue&type=script&lang=ts&"
export * from "./LocationPin.vue?vue&type=script&lang=ts&"
import style0 from "./LocationPin.vue?vue&type=style&index=0&id=40a3b1c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a3b1c6",
  null
  
)

export default component.exports